// eslint-disable-next-line
import React, {lazy, Suspense} from "react";
// noinspection ES6CheckImport
import {Route, Switch} from "react-router-dom";
import {connect} from 'react-redux';
import Error404 from "./modules/error/404";
import PrivateRoute from "./private-route";
import {isAuthorizedToken} from "./modules/user-management/login/check-token-validity";
import FullPageLoading from "./components/loading-top-page-authorized";


// noinspection JSCheckFunctionSignatures
const Administration = lazy(() => import('./modules/admin'));

class AppPrivate extends React.Component {

    componentDidMount() {
        // Get access token from redux store
        let preAuthAccessToken = this.props.auth.token;
        // If it's blank, try to get token from local storage
        if (!preAuthAccessToken) {
            preAuthAccessToken = JSON.parse(localStorage.getItem('auth'));
        }
        // If we have access token, try to check the access token authorization
        if (preAuthAccessToken) {
            this.props.isAuthorizedToken();
        }
    }
    render() {
        return (
            <Suspense fallback={<FullPageLoading/>}>
            <Switch>
                <PrivateRoute exact path="/" component={Administration}/>
                <PrivateRoute exact path="/admin" component={Administration}/>
                <PrivateRoute exact path="/admin/:section" component={Administration}/>
                <Route path="*" component={Error404}/>
            </Switch>
        </Suspense>

        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        request: state.request
    }
}


export default connect(mapStateToProps, {isAuthorizedToken})(AppPrivate);
